"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRequiredFilesForTool = checkRequiredFilesForTool;
const altiumRequiredFiles_1 = require("./Altium/altiumRequiredFiles");
const orcadRequiredFiles_1 = require("./OrCAD/orcadRequiredFiles");
const xpeditionRequiredFiles_1 = require("./Xpedition/xpeditionRequiredFiles");
function checkRequiredFilesForTool(tool, context) {
    switch (tool) {
        case 'altium':
            return (0, altiumRequiredFiles_1.checkAltiumRequiredFiles)(context);
        case 'orcad':
            return (0, orcadRequiredFiles_1.checkOrcadRequiredFiles)(context);
        case 'xpedition':
            return (0, xpeditionRequiredFiles_1.checkXpeditionRequiredFiles)(context);
        default:
            return [];
    }
}
//# sourceMappingURL=required-files.js.map